import { Component } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { catchError, map, throwError } from "rxjs";
import { ProfileService } from "src/app/modules/myVirsa/services/profile.service";
import { AuthService } from "src/app/services/auth.service";
import { transform } from "src/app/utils/date-utils";

@Component({
  selector: "app-iccr-header",
  templateUrl: "./iccr-header.component.html",
  styleUrls: ["./iccr-header.component.scss"],
})
export class IccrHeaderComponent {
  userSignedIn: boolean = false;
  data: any;

  Cap(arg0: string): string {
    return transform(arg0);
  }

  constructor(
    private router: Router,
    private auth: AuthService,
    private profile: ProfileService,
    private snackbar: MatSnackBar
  ) {
    this.router.events.subscribe(() => {
      this.checkLogin();
    });
  }

  ngOnInit(): void {
    this.checkLogin();
  }

  checkLogin() {
    if (this.auth.isLoggedIn()) {
      this.userSignedIn = true;
      this.getData();
    } else {
      this.userSignedIn = false;
    }
  }

  getData(): void {
    this.profile
      .getProfile()
      .pipe(
        map((res: any) => {
          this.data = res.details;
        }),
        catchError((error) => {
          return throwError(error.massage || error);
        })
      )
      .subscribe();
  }

  signOut() {
    this.auth.logout();
    this.snackbar.open("SignOut Successful", "Ok", { duration: 4000 });
    this.checkLogin();
    this.router.navigate(["/login"]);
  }
}
